import { orderIsRetailType } from '../../gameday/data/gameDay-data-orders.calculation';
import { getViewOrder } from '../../gameday/mappers/gameDay-orders.transfomations';
import { Part, Tranche } from '../../gameday/data/gameDay-data.transformations';
import { AccountManager } from '../../state/data/state';
import { TrancheOrder } from '../models/tranche-order';
import { GameDayModel } from '../../models/gameday-model';

const formatRetailIndicator = (order: GameDayModel.Order): string =>
  orderIsRetailType(order)
    ? `${order.category.name || ''}${
        !order.category.groupCode ? ' Retail' : ''
      }`
    : '';

/**
 * Return tranche orders located in the tranche parts or orders in tranche,
 * otherwise returns empty orders collection for tranche which is not defined.
 *
 * @param  tranche
 * @returns TrancheOrder
 */
export function trancheOrdersMapper(tranche: Tranche): TrancheOrder[] {
  if (!tranche) {
    return [];
  } else if (!tranche.parts) {
    return [].concat(
      tranche.orders &&
        tranche.orders
          .map((order: GameDayModel.Order) => ({
            // ToDo Check out types compatibility
            // TrancheOrder should have commented field below
            ...(order as any)
            // categoryColor: undefined,
            // manager: undefined,
            // account: undefined,
            // maturityDate: undefined,
            // amountFormatted: undefined,
            // linkType: undefined,
            // retailInd: undefined,
            // series: "",
            // maturity: "",
            // priority: "",
            // orderType: ""
          }))
          .sort(
            (prevOrder: TrancheOrder, nextOrder: TrancheOrder) =>
              +nextOrder.orderNumber - +prevOrder.orderNumber
          )
    );
  }

  return tranche.parts
    .reduce((prev: TrancheOrder[], { orders, color }: Part) => {
      return [
        ...prev,
        ...orders.map((order: GameDayModel.Order) => ({
          ...getViewOrder(order),
          orderType: order.orderType.code,
          retailInd: formatRetailIndicator(order),
          categoryColor: color
        }))
      ];
    }, [])
    .sort(
      (prevOrder: TrancheOrder, nextOrder: TrancheOrder) =>
        +nextOrder.orderNumber - +prevOrder.orderNumber
    );
}

const checkAppliedFilters = (
  issueSeriesIds: string[],
  filteredSeriesIds: string[]
): boolean =>
  filteredSeriesIds &&
  issueSeriesIds &&
  issueSeriesIds.length !== filteredSeriesIds.length;

/**
 * Return flag if tranche orders are filtered by any applied filter:
 * 1) by series
 * 2) by sealed bid indicator
 * 3) by ignore stock filter
 * 4) by account manager
 *
 * @param  deal
 * @param  seriesId
 * @param  searchByAccountManager
 * @param  ignoreStocks
 * @param  isSealedBid
 * @returns boolean
 */
export function isTrancheOrdersFilteredMapper({
  deal,
  seriesId,
  searchByAccountManager,
  ignoreStocks,
  isSealedBid
}: {
  deal: GameDayModel.Deal;
  seriesId: string[];
  searchByAccountManager: AccountManager;
  ignoreStocks: boolean;
  isSealedBid: boolean;
}): boolean {
  const issueSeriesIds: string[] = deal.series.map(
    (series: GameDayModel.Series) => series.id
  );
  const isSeriesFilterApplied: boolean = checkAppliedFilters(
    issueSeriesIds,
    seriesId
  );

  return (
    !!isSeriesFilterApplied ||
    isSealedBid ||
    ignoreStocks ||
    !!searchByAccountManager
  );
}
